<!--
 * @Author: your name
 * @Date: 2019-12-17 23:09:31
 * @LastEditTime : 2020-01-22 20:57:33
 * @LastEditors  : Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \周记 张经伟e:\gi劳务\src\views\creditEvaluation\index.vue
 -->
<template>
  <div id="creditEvaluation">
    <div class="creditEvaluation_main" :style="{'backgroundImage':'url(' + img + ')'}">
      <nav-bar title="信用评价" :show="true" color="#fff"></nav-bar>
    </div>
    <div class="creditEvaluation_bottom" @click="onJumpPage">
      <img src="../../assets/images/creditEvaluation/button@2x.png" alt="立即认可" />
    </div>
  </div>
</template>
<script>
import NavBar from '@/component/NavBar'
import { getData } from '@/api/index'
import { Toast } from 'vant'
export default {
  name: 'creditEvaluation',
  data() {
    return {
      img: '',
    }
  },
  methods: {
    onJumpPage() {
      this.$router.push({
        name: 'home'
      })
    }
  },
  components: {
    NavBar
  },
  created() {
    getData({
      type: 1
    })
    .then(res=> {
      if(res.state == 200) {
        this.img = res.datas.creditEvaluation;
      }
    })
  }
}
</script>
<style scoped lang='scss'>
#creditEvaluation {
  .van-nav-bar .van-icon {
    color: #000 !important;
  }
  background-color: #f8f8f8;
  padding-bottom: 0.3rem;
}
.creditEvaluation_main {
  width: 100%;
  height: 24.61rem;
  // background-image: url('../../assets/images/creditEvaluation/h.png');
  background-size: 100%;
}
.creditEvaluation_bottom {
  width: 6.9rem;
  background-color: #ffffff;
  margin: 0 auto;
  text-align: center;
}
.creditEvaluation_bottom > img {
  height: 1.56rem;
  width: 6.32rem;
}
</style>



// WEBPACK FOOTER //
// src/views/creditEvaluation/index.vue